'use strict'

/**
 * ダッシュボード×項目マトリクス画面（10702）。 ダッシュボード・グラフと CHROFY 項目の対応表を表示する。
 *
 * 構成:
 *
 * - DashboardItemMatrix（Main）: 権限チェック（corporationNumber 有無）
 * - DashboardItemMatrixContent: メインストアから corporationNumber / accPeriod を読み取り（フィーチャー ストア Provider の外側で読むこと）、フィーチャーストアで
 *   MatrixBody を包む
 * - MatrixBody 以下: フィーチャーストア（extra/store.js）を購読し、セクションごとにメモ化して再レンダーを最小化する
 */

import React from 'react'
import { useSelector } from 'react-redux'
import Forbidden from '../../_components/Forbidden'
import { DashboardMatrixProviderStore } from './extra/store'
import MatrixBody from './components/MatrixBody'

/**
 * Content: メインストアから corporationNumber / accPeriod を取得し、フィーチャーストア Provider 配下で MatrixBody を表示する。 useSelector
 * はこの時点ではメインストアを参照する（DashboardMatrixProviderStore はこの戻り値の内側で適用されるため）。
 *
 * @returns {JSX.Element}
 */
const DashboardItemMatrixContent = () => {
  const corporationNumber = useSelector((s) => s.company?.corporationNumber) || ''
  const accPeriod = useSelector((s) => s.company?.accPeriod) || ''
  return (
    <DashboardMatrixProviderStore>
      <MatrixBody corporationNumber={corporationNumber} accPeriod={accPeriod} />
    </DashboardMatrixProviderStore>
  )
}

export { DashboardItemMatrixContent }

/**
 * DashboardItemMatrix（Main）: 権限チェック・Content を表示。 ダッシュボード×データ項目対応表（画面ID: 10702）のラッパー。PrivateRoute 経由で表示。
 * corporationNumber がない場合は Forbidden、 otherwise Content を表示。
 *
 * @returns {JSX.Element}
 */
const DashboardItemMatrix = () => {
  const corporationNumber = useSelector((s) => s.company?.corporationNumber)

  // 権限チェック: 本画面はログイン済みであれば全ユーザーが閲覧可能（追加の権限チェック不要）。
  // ただし、corporationNumber がない場合は Forbidden を表示。
  if (!corporationNumber) {
    return <Forbidden />
  }

  return <DashboardItemMatrixContent />
}

export default DashboardItemMatrix
